import React from 'react';
import Breadcrumb from '../../../core/common/Breadcrumb/breadcrumb';
import { all_routes } from '../../router/all_routes';
import { Link } from 'react-router-dom';
import { t } from '../../../lang/index';

const FAQ = () => {
  const routes = all_routes;
  const breadcrumbs = [
    { label: 'FAQ', link: routes.home1, active: false },
    { label: 'Pages', active: false },
    { label: 'FAQ', active: true },
  ];

  const questions = t('home.updateSection.faq.questions');

  return (
    <>
      <Breadcrumb title="FAQ" breadcrumbs={breadcrumbs} backgroundClass="breadcrumb-bg-01" />

      <div className="content">
        <div className="container">
          {/* FAQ Section */}
          <div className="faq">
            <div className="container">
              <div className="faq-sec p-0">
                <div className="row">
                  <div className="col-lg-10 mx-auto">
                    <div className="accordion" id="accordionFaq">
                      {questions.map((q: any, index: number) => {
                        const collapseId = `faq-collapse${index + 1}`;
                        return (
                          <div
                            key={index}
                            className={`accordion-item mb-3 wow fadeInUp ${index === 0 ? 'show pb-3' : ''}`}
                            data-wow-delay={`${0.2 + index * 0.2}s`}
                          >
                            <h2 className="accordion-header">
                              <button
                                className={`accordion-button ${index !== 0 ? 'collapsed' : ''}`}
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target={`#${collapseId}`}
                                aria-controls={collapseId}
                              >
                                {q.question}
                              </button>
                            </h2>
                            <div
                              id={collapseId}
                              className={`accordion-collapse collapse ${index === 0 ? 'show' : ''}`}
                              data-bs-parent="#accordionFaq"
                            >
                              <div className="accordion-body">
                                <p className="mb-0">{q.answer}</p>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* /FAQ Section */}

          <div className="row justify-content-center">
            <div className="col-lg-6">
              <div className="que-sec text-center">
                <h4 className="mb-3">{t('home.updateSection.faq.subtitle')}</h4>
                <p className="mb-3">
                  {t('home.updateSection.faq.contactUsText')}
                </p>
                <div className="d-flex justify-content-center">
                  <Link to="/pages/contact-us" className="btn btn-primary d-flex align-items-center justify-content-center">
                    {t('home.updateSection.faq.contactButton')}
                    <i className="isax isax-arrow-right-3 ms-1"></i>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Page Wrapper */}
    </>
  );
};

export default FAQ;
